import React from 'react';

import ScheduleQueue from 'src/dropInClinic/components/ScheduleQueue';
import type { ScheduleLogQueue, ScheduleMap } from 'src/dropInClinic/hooks/useScheduleLogs';

const BhNpMatchedRequests = ({
  queue,
  scheduleMap,
}: {
  queue: ScheduleLogQueue[];
  scheduleMap: ScheduleMap;
}) => {
  const requestIds = Object.values(scheduleMap)
    .flatMap(x =>
      x.blocks.filter(block => block.schedulingDecision?.consideration === 'BH_NP_MATCHED'),
    )
    .map(x => x.requestId)
    .filter(x => x !== null);
  const requestIdSet = new Set(requestIds);
  const requests = queue.filter(request => requestIdSet.has(request.requestId));

  return <ScheduleQueue queue={requests} />;
};

export default BhNpMatchedRequests;
